import { render, staticRenderFns } from "./SeedCard.vue?vue&type=template&id=7527193c&scoped=true&"
import script from "./SeedCard.vue?vue&type=script&lang=js&"
export * from "./SeedCard.vue?vue&type=script&lang=js&"
import style0 from "./SeedCard.vue?vue&type=style&index=0&id=7527193c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527193c",
  null
  
)

export default component.exports